import { AbstractControl } from '@angular/forms';

export type FormErrorMap = { [key: string]: { [key: string]: string } };

export const hasFormControlErrorMessages = (
  control: AbstractControl | null,
): boolean => {
  if (control == null) {
    return false;
  }

  return Object.keys(control.errors || {}).length > 0;
};

export const getFormControlErrorMessages = (
  control: AbstractControl | null,
  controlName: string,
  errorMap: FormErrorMap,
): string[] | null => {
  if (control == null || controlName == null || errorMap == null) {
    return null;
  }

  const errorKeys = Object.keys(control.errors || {});

  const result = errorKeys.reduce((prev: string[], errorKey: string) => {
    if (!(controlName in errorMap)) {
      return prev;
    }

    const controlErrors = errorMap[controlName];
    if (!(errorKey in controlErrors)) {
      return prev;
    }

    return [...prev, controlErrors[errorKey]];
  }, []);

  return result;
};
